export enum ShipmentCode {
  DS = 'DS',
  IO = 'IN_OUT',
  STOCK = 'STOCK',
}
